// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"209":"91a52fca","249":"1453e8c0","452":"5b8d9a80","473":"5966f617","488":"dd78af85","607":"5db79354","743":"d4796d42","845":"5db79354","864":"bddf2baa","935":"94733557","954":"695d3c85","988":"5db79354"}[chunkId] + ".chunk.js";
};